exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1bwLdGNDdiLBIc3ccC_xOh{width:100%;clear:both;font-size:18px;font-weight:600;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._1bwLdGNDdiLBIc3ccC_xOh{border-top:1px solid \"[theme:neutralLight, default:#eaeaea]\";padding-top:20px}html[dir] ._1bwLdGNDdiLBIc3ccC_xOh ._1AiQNqV_piw983KXaU9tw{margin-bottom:10px}", ""]);
// Exports
exports.locals = {
	"container": "_1bwLdGNDdiLBIc3ccC_xOh",
	"storageAccount": "_1AiQNqV_piw983KXaU9tw"
};